import React, { ReactElement } from 'react'
import styles from './MobileStartScreen.module.scss'
import { YoutubeVideos } from '../../components/youtube-videos/YoutubeVideos'
import { MobileButton, MobileTitleLarge } from '../../Typography'
import { NextEventData } from '../../stores/NextEventStore'
import { useNavigate } from 'react-router-dom'
import { URLS } from '../../content/urls'
import { Slideshow } from '../../components/slideshow/Slideshow'

type Props = {
  data: NextEventData[]
}

type EventViewProps = {
  data: NextEventData
}

export const MobileStartScreen: React.FC<Props> = ({ data }) => {
  const slides: React.ReactNode[] =
    data.length === 0
      ? [
          <div className={styles.container} key='fallback'>
            <div className={styles.backgroundImage}>
              <img
                src={URLS.startScreenPlaceholderBackground}
                alt='Bannerhintergrund zur nächsten Show'
              />
            </div>
            <div className={styles.centeredBox}>
              <img src={URLS.fightbackPlaceholderLogo} alt='Bannerlogo zur nächsten Show' />
              <MobileTitleLarge>Ankündigungen folgen in Kürze…</MobileTitleLarge>
            </div>
          </div>,
        ]
      : data.map((eventData, index) => <MobileEventView key={index} data={eventData} />)

  return (
    <>
      <Slideshow slides={slides} />
      <YoutubeVideos />
    </>
  )
}

const MobileEventView = ({ data }: EventViewProps): ReactElement => {
  const navigate = useNavigate()

  return (
    <div className={styles.container}>
      <div className={styles.backgroundImage}>
        <img src={data.eventHintergrund} alt={'Bannerhintergrund zur nächsten Show'} />
      </div>
      <div className={styles.centeredBox}>
        <img src={data.eventLogo} alt={'Bannerlogo zur nächsten Show'} />
        <div className={styles.infoBox}>
          <MobileTitleLarge>
            {data.eventDatum} {data.eventHalle}
          </MobileTitleLarge>
          <MobileTitleLarge>
            Einlass: {data.eventEinlass} | Beginn: {data.eventBeginn}
          </MobileTitleLarge>
          <div className={styles.buttonBox}>
            <div
              className={styles.matchCardButton}
              onClick={(): void => {
                navigate(data.slug)
              }}
            >
              <MobileButton darkFont={true}>EVENT INFOS</MobileButton>
            </div>
            {data.eventTickets.trim().length > 0 && (
              <a
                className={styles.ticketButton}
                href={data.eventTickets}
                target='_blank'
                rel='noreferrer'
              >
                <MobileButton>TICKETS</MobileButton>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
